<template>
  <!--  FEATURES TABS  -->

  <section
    class="mx-auto lg:mt-[200px] mt-[145px] max-w-[1140px] px-[25px] xl:px-0 lg:h-[750px]"
  >
    <div
      class="mx-auto lg:flex justify-between lg:w-[1090px] lg:pr-[60px] lg:h-[164px] shadow-2xl rounded-r-[10px] border-l-4 border-[#2D8CFF]"
    >
      <h2
        class="px-auto top-full px-[25px] py-[15px] mt-[20px] text-[30px] font-bold text-[#292d34]"
      >
        Engage and keep members<br />
        up to date on new offers.
      </h2>

      <ul
        class="mb-0 list-none py-[10px] lg:flex justify-between gap-2 px-[30px]"
      >
        <li
          class="text-center my-[10px] rounded-[5px] cursor-pointer py-[15px]"
          v-on:click="toggleTabs(1)"
          v-bind:class="{
            'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out':
              openTab !== 1,
            'text-[#292d34] bg-[#2d8bff3a] ease-in ': openTab === 1
          }"
        >
          <img
            class="my-auto mx-auto"
            :src="$filters.media_path('/images/blue-megaphone.svg')"
            alt="Platforma video channel video scheduler."
            v-bind:class="{ hidden: openTab !== 1, 'block ': openTab === 1 }"
          />

          <img
            class="my-auto mx-auto"
            :src="$filters.media_path('/images/megaphone-1.svg')"
            alt="Platforma video channel video scheduler."
            v-bind:class="{ hidden: openTab !== 2, 'block ': openTab === 2 }"
          />

          <a
            class="text-sm font-bold uppercase px-5 py-3 block leading-normal cursor-pointer lg:w-[198px] rounded-[5px]"
          >
            DASHBOARD<br />
            ANNOUNCEMENTS
          </a>
        </li>

        <li
          class="text-center my-[10px] rounded-[5px] cursor-pointer py-[15px]"
          v-on:click="toggleTabs(2)"
          v-bind:class="{
            'text-[#B9BEC7] hover:text-[#7c828d] hover:ease-in-out':
              openTab !== 2,
            'text-[#292d34] bg-[#49CCF93a] ease-in ': openTab === 2
          }"
        >
          <img
            class="my-auto mx-auto h-[36px]"
            :src="$filters.media_path('/images/grey-bell.svg')"
            alt="Platforma video channel video scheduler."
            v-bind:class="{ hidden: openTab !== 1, 'block ': openTab === 1 }"
          />

          <img
            class="my-auto mx-auto h-[36px]"
            :src="$filters.media_path('/images/bell-icon-turqoise.svg')"
            alt="Platforma video channel video scheduler."
            v-bind:class="{ hidden: openTab !== 2, 'block ': openTab === 2 }"
          />

          <a
            class="text-sm font-bold uppercase px-5 py-3 block leading-normal cursor-pointer lg:w-[198px] rounded-[5px]"
          >
            BROADCAST<br />
            NOTIFICATIONS
          </a>
        </li>
      </ul>
    </div>

    <div
      class="dashboard-card-1 gap-10 lg:hidden"
      v-bind:class="{
        hidden: openTab !== 1,
        'block py-5 bg-no-repeat ': openTab === 1
      }"
    >
      <img
        class="w-full"
        :src="
          $filters.media_path(
            '/images/membership-site-dashboard-notifications.png'
          )
        "
        alt="Platforma video channel video scheduler."
      />

      <div class="my-auto">
        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34]"
        >
          Always be closing with Dynamic dashboards.
        </h2>
        <hr
          class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
        />

        <p class="mt-[25px] text-lg text-[#7C828D]">
          Stay consistently engaging with an announcement on their home screen.
          Members can’t help but see the persistent offer every time that they
          login to their account. Change image, text, button link, and more.
        </p>
      </div>
    </div>

    <div
      class="broadcast-card-2 gap-10 lg:hidden"
      v-bind:class="{
        hidden: openTab !== 2,
        'block py-5 bg-no-repeat ': openTab === 2
      }"
    >
      <img
        class="p-[20px] lg:w-[601px] lg:h-[374px] my-auto"
        :src="
          $filters.media_path(
            '/images/membership-site-broadcast-notifications.png'
          )
        "
        alt="Platforma video channel video scheduler."
      />

      <div class="my-auto">
        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34]"
        >
          Remind and Sell on the fly.
        </h2>
        <hr
          class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
        />
        <p class="mt-[25px] text-lg text-[#7C828D]">
          DM your members with a mass broadcast notification that drops right
          into each member’s account. Remind them of events or offers that are
          upcoming, or just use to increase engagement.
        </p>
      </div>
    </div>

    <!-- <div class="flex flex-wrap mt-10">

          

      </div> -->

    <!-- CONTENT TAB SECTION -->
    <div
      class="hidden relative lg:flex min-w-0 break-words w-full mb-6 pt-3 lg:h-[554px]"
    >
      <div class="lg:flex">
        <div class="tab-content tab-space lg:flex">
          <div
            class="dashboard-card-1 flex gap-10"
            v-bind:class="{
              hidden: openTab !== 1,
              'block p-[30px] py-5 bg-no-repeat ': openTab === 1
            }"
          >
            <img
              class="w-[601px] my-auto h-[334px]"
              :src="
                $filters.media_path(
                  '/images/membership-site-dashboard-notifications.png'
                )
              "
              alt="Platforma video channel video scheduler."
            />

            <div class="my-auto">
              <h2
                class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34]"
              >
                Always be closing with Dynamic dashboards.
              </h2>
              <hr
                class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
              />

              <p class="mt-[25px] text-lg text-[#7C828D]">
                Stay consistently engaging with an announcement on their home
                screen. Members can’t help but see the persistent offer every
                time that they login to their account. Change image, text,
                button link, and more.
              </p>
            </div>
          </div>

          <div
            class="broadcast-card-2 flex gap-10"
            v-bind:class="{
              hidden: openTab !== 2,
              'block  p-[30px] py-5 bg-no-repeat ': openTab === 2
            }"
          >
            <img
              class="p-[20px] lg:w-[601px] lg:h-[374px] my-auto"
              :src="
                $filters.media_path(
                  '/images/membership-site-broadcast-notifications.png'
                )
              "
              alt="Platforma video channel video scheduler."
            />

            <div class="my-auto">
              <h2
                class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34]"
              >
                Remind and Sell on the fly.
              </h2>
              <hr
                class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
              />
              <p class="mt-[25px] text-lg text-[#7C828D]">
                DM your members with a mass broadcast notification that drops
                right into each member’s account. Remind them of events or
                offers that are upcoming, or just use to increase engagement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CONTENT TAB END -->
  </section>

  <!--  FEATURES TABS END  -->
</template>

<!-- SCRIPTS -->

<script>
export default {
  name: 'pink-tabs',
  data() {
    return {
      openTab: 1
    };
  },

  methods: {
    toggleTabs: function (tabNumber) {
      this.openTab = tabNumber;
    }
  }
};
</script>

<!-- STYLES -->

<style>
/* .your-way-tab{
      background-image: url(../media/images/two-dots.svg);
    background-size: auto;
    background-position: center;
    
    } */
.dashboard-card-1 {
  background-image: url(../media/images/gradient-shape-tab-bg.svg);
  background-position: left;
}
.broadcast-card-2 {
  background-image: url(../media/images/gradient-shape-tab-bg-turqoise.svg);
  background-position: left;
}
</style>
